
import Vue from "vue";

export default Vue.extend({
  name: "Footer",
  data() {
    return {
      footerText: "Copyright © 2025 Tarek Mongy. All Rights Reserved."
    }
  },
  async created() {
    try {
      const res = await fetch("/api/settings.php");
      if (res.ok) {
        const data = await res.json();
        if (data.footerText) {
          this.footerText = data.footerText;
        }
      }
    } catch (e) {
      // Fallback to default if API fails
    }
  }
});
